export default __webpack_public_path__ + "static/jan_deckruede_-022c42f3f00dc6a1fd63ce652228e1e9.jpg";